import { Layout } from "@/components/Layout";

export default function Privacy() {
  return (
    <Layout>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-16">
        <h1 className="font-display font-extrabold uppercase tracking-wide text-4xl text-[#0f172a]">Privacy Policy</h1>
        <div className="mt-6 text-slate-600 space-y-4 leading-relaxed text-sm" data-testid="privacy-content">
          <p>We respect your privacy. This policy explains what information YourRaceFinder collects and how it is used.</p>

          <h3 className="font-bold text-slate-800 text-base">What We Collect</h3>
          <p>When you create a runner account on YourRaceFinder, we collect only:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Your name</li>
            <li>Your email address</li>
          </ul>
          <p>We do not intentionally collect or store your IP address, browser information, device information, location data, race activity, or other personal information through your runner account.</p>

          <h3 className="font-bold text-slate-800 text-base">How We Use Your Information</h3>
          <p>Your name and email address are used to:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Create and manage your YourRaceFinder account</li>
            <li>Allow you to log in to the platform</li>
            <li>Contact you when necessary regarding your account or YourRaceFinder services</li>
          </ul>
          <p>We do not sell or share your personal information for advertising or marketing purposes.</p>

          <h3 className="font-bold text-slate-800 text-base">Race Views and Website Statistics</h3>
          <p>YourRaceFinder may display general or aggregated statistics about race listings, such as the number of times a race has been viewed. These statistics are not intended to identify individual runners or visitors.</p>

          <h3 className="font-bold text-slate-800 text-base">Race Registration</h3>
          <p>YourRaceFinder is a race discovery platform. Race registration is handled directly by the race organizer through the registration link provided on the race listing. YourRaceFinder does not collect your registration information when you register for a race through an organizer's website.</p>

          <h3 className="font-bold text-slate-800 text-base">Organizers</h3>
          <p>Race organizers may provide information about their races, including race details, dates, categories, registration links, medal images and merchandise images. Information submitted by organizers is used to display and promote their race listings on YourRaceFinder.</p>

          <h3 className="font-bold text-slate-800 text-base">Cookies</h3>
          <p>YourRaceFinder does not intentionally use cookies to collect personal information or track users for advertising purposes.</p>

          <h3 className="font-bold text-slate-800 text-base">Changes to This Policy</h3>
          <p>We may update this Privacy Policy from time to time. Any changes will be posted on this page.</p>

          <p className="text-slate-400">Last updated: September 2026</p>
        </div>
      </div>
    </Layout>
  );
}
